import { createSlice } from "@reduxjs/toolkit";
import {
  createGoogleAuthInfoThunk,
  createLineThunk,
  deleteLineThunk,
  getGoogleAuthInfoThunk,
  getLinesThunk,
  assignAgentToLineThunk,
  updateLineThunk,
} from "../actions/line.action";
import { ILineResponse } from "../../models/line.model";

export interface LineState {
  lines: {
    lines: ILineResponse[];
    count: number;
    pagination: {
      totalItems: number;
      totalPages: number;
      pageSize: number;
      currentPage: number;
    };
  };
  loading: boolean;
  error: string | null;
  googleAuthInfo: {
    data: any;
  };
}

// Initial state
const initialState: LineState = {
  lines: {
    lines: [],
    count: 0,
    pagination: {
      totalItems: 0,
      totalPages: 0,
      pageSize: 0,
      currentPage: 0,
    },
  },
  googleAuthInfo: {
    data: null,
  },
  loading: false,
  error: null,
};

// Auth slice
const lineSlice = createSlice({
  name: "line",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createLineThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createLineThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(createLineThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(createGoogleAuthInfoThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createGoogleAuthInfoThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(createGoogleAuthInfoThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(getGoogleAuthInfoThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGoogleAuthInfoThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.googleAuthInfo.data = action.payload.data;
        state.error = null;
      })
      .addCase(getGoogleAuthInfoThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(getLinesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLinesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.lines = action.payload.data;
        state.error = null;
      })
      .addCase(getLinesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(updateLineThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateLineThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateLineThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(deleteLineThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLineThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteLineThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(assignAgentToLineThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(assignAgentToLineThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(assignAgentToLineThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const {} = lineSlice.actions;
export default lineSlice.reducer;
